import React from "react"
import PPMatchingProductImage from "../matching/PPMatchingProductImage"
import PPMatchingProductFacts from "../matching/PPMatchingProductFacts"
import PPDematchingChainToggle from "./PPDematchingChainToggle"

export default function PPDematchingPairRow({ pair, priceLang, linked, toggling, onToggleLink }) {
    if (!pair) {
        return null
    }

    return (
        <div className={"pp-dematching-pair" + (!linked ? " pp-dematching-pair--unlinked" : "")}>
            <div className="pp-dematching-pair__customer pp-matching-master-card">
                <div className="pp-matching-card-row">
                    <PPMatchingProductImage
                        imageUrl={pair.customerProduct?.imageUrl}
                        className="pp-matching-product-img--master"
                    />
                    <div className="pp-matching-card-row__content">
                        <PPMatchingProductFacts product={pair.customerProduct} isMaster priceLang={priceLang} />
                    </div>
                </div>
            </div>

            <div className="pp-dematching-pair__chain-wrap">
                <PPDematchingChainToggle linked={linked} loading={toggling} onToggle={onToggleLink} />
            </div>

            <div className="pp-dematching-pair__foreign pp-matching-candidate-card">
                <div className="pp-matching-card-row">
                    <PPMatchingProductImage
                        imageUrl={pair.foreignProduct?.imageUrl}
                        className="pp-matching-product-img--candidate"
                    />
                    <div className="pp-matching-card-row__content">
                        <PPMatchingProductFacts product={pair.foreignProduct} />
                    </div>
                </div>
            </div>
        </div>
    )
}
